import { render, staticRenderFns } from "./YesNoSwitch.vue?vue&type=template&id=5ed6153e"
import script from "./YesNoSwitch.vue?vue&type=script&lang=js"
export * from "./YesNoSwitch.vue?vue&type=script&lang=js"
import style0 from "./YesNoSwitch.vue?vue&type=style&index=0&id=5ed6153e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports